/**
 * InputRadio component
 * @returns <InputRadio />
 */
import { useEffect, useState } from "react"

const InputRadio = (props) => {
  const {
    type,
    id,
    name,
    label,
    value,
    isRequired,
    extraClass,
    changed,
    isChecked,
    color,
    clicked,
    styles
  } = props;

  // Radio
  if (type === "radio") {
    return (
      <div className="input">
        <div className={`input__field --radio ${extraClass ? extraClass : ""}`}>
          <input className={`input__radio`} type="radio" name={name} required={isRequired ? true : false} value={value} checked={isChecked} id={id} onChange={changed} />
          <label htmlFor={name} className={`input__radio__label`}>{label}</label>
        </div>

        {/* Message box to display a message 
            types: ok, error
        */}
        {/* <div className="input__message">
          <img src={imageSrc} alt="" />

          <p>Hubo un error</p>
        </div> */}
      </div>
    )
  }

  // Color input
  if (type === "color") {
    return (
      <div className="input">
        <div className="input__field --color">
          <input className={`input__color`} type="radio" name={name} required={isRequired ? true : false} value={value} id={id} onChange={changed} checked={isChecked} onClick={clicked} readOnly />
          <label htmlFor={name} className={`input__color__label --${color}`} style={styles}></label>
        </div>
      </div>
    )
  }
}

export default InputRadio